export type TOrderBy<T> = {
  column: T
  descOrder: boolean
}

export const EList = {
  PATIENT_LIST: 'PATIENT_LIST',
  MESSAGE_PROGRAMMED_LIST: 'MESSAGE_PROGRAMMED_LIST',
  CONTENT_LIST: 'CONTENT_LIST',
  PERMISSION_LIST: 'PERMISSION_LIST',
} as const

export type EList = (typeof EList)[keyof typeof EList]

const setListPreferedOrder = <T>(list: EList, orderBy: TOrderBy<T>) => {
  localStorage?.setItem(`${list}`, JSON.stringify(orderBy))
}

const getListPreferedOrder = <T>(list: EList): TOrderBy<T> => {
  const item = localStorage?.getItem(list)
  return item && JSON.parse(item)
}

export { setListPreferedOrder, getListPreferedOrder }
